/**
 * The nav glyphs and the chevrons, inline.
 *
 * A whole icon package for five shapes would be the larger dependency: these
 * are drawn in the same 24-grid, 1.75-stroke, round-cap idiom the mobile app's
 * lucide set uses, so the two surfaces read as one product.
 */
function Glyph({ children }: { children: React.ReactNode }) {
  return (
    <svg
      className="glyph"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

/** Referrals: the book of people someone brought in. */
export function UsersIcon() {
  return (
    <Glyph>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </Glyph>
  );
}

/** Notifications: what was sent, and what became of it. */
export function BellIcon() {
  return (
    <Glyph>
      <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
      <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
    </Glyph>
  );
}

/** Staff: who holds a role, which is an access decision. */
export function ShieldIcon() {
  return (
    <Glyph>
      <path d="M12 22s8-3.2 8-9V5.5L12 2 4 5.5V13c0 5.8 8 9 8 9z" />
      <path d="m9 12 2 2 4-4" />
    </Glyph>
  );
}

/** Back, in the phone's top bar. */
export function ChevronLeftIcon() {
  return (
    <Glyph>
      <path d="m15 18-6-6 6-6" />
    </Glyph>
  );
}

/** A list row that opens something, and the rail's account row. */
export function ChevronRightIcon() {
  return (
    <Glyph>
      <path d="m9 18 6-6-6-6" />
    </Glyph>
  );
}

export function PhoneIcon() {
  return (
    <Glyph>
      <rect x="6" y="2" width="12" height="20" rx="2.5" />
      <path d="M11 18h2" />
    </Glyph>
  );
}
